/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { ApiError } from '../model/apiError';
import { EstadoEvento } from '../model/estadoEvento';
import { KoguiEvento } from '../model/koguiEvento';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class KoguiEventosService {

    protected basePath = 'https://virtserver.swaggerhub.com/yohanyflores/kogui/1.0.0';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    /**
     * Detalle de un evento
     * EL detalle de un evento.
     * @param eventoId El id de un evento asociado a la empresa.
     * @param xFcmtoken 
     * @param $fields 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiEventoById(eventoId: string, xFcmtoken?: string, $fields?: string, observe?: 'body', reportProgress?: boolean): Observable<KoguiEvento>;
    public getKoguiEventoById(eventoId: string, xFcmtoken?: string, $fields?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<KoguiEvento>>;
    public getKoguiEventoById(eventoId: string, xFcmtoken?: string, $fields?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<KoguiEvento>>;
    public getKoguiEventoById(eventoId: string, xFcmtoken?: string, $fields?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (eventoId === null || eventoId === undefined) {
            throw new Error('Required parameter eventoId was null or undefined when calling getKoguiEventoById.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<KoguiEvento>(`${this.configuration.basePath}/kogui/eventos/${encodeURIComponent(String(eventoId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene la lista de eventos paginadas. por defecto se ordenan en orden descendiente de creacion.
     * Al obtener las eventosd puede especificar una paginacion y orden para mostrarlo.
     * @param xFcmtoken 
     * @param $filter 
     * @param $size 
     * @param $page 
     * @param $sort 
     * @param $fields 
     * @param $search Permite buscar por fulltext.
     * @param estado Especifica el estado a buscar.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiEventos(xFcmtoken?: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, estado?: EstadoEvento, observe?: 'body', reportProgress?: boolean): Observable<Array<KoguiEvento>>;
    public getKoguiEventos(xFcmtoken?: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, estado?: EstadoEvento, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<KoguiEvento>>>;
    public getKoguiEventos(xFcmtoken?: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, estado?: EstadoEvento, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<KoguiEvento>>>;
    public getKoguiEventos(xFcmtoken?: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, estado?: EstadoEvento, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($filter !== undefined && $filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>$filter);
        }
        if ($size !== undefined && $size !== null) {
            queryParameters = queryParameters.set('$size', <any>$size);
        }
        if ($page !== undefined && $page !== null) {
            queryParameters = queryParameters.set('$page', <any>$page);
        }
        if ($sort !== undefined && $sort !== null) {
            queryParameters = queryParameters.set('$sort', <any>$sort);
        }
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }
        if ($search !== undefined && $search !== null) {
            queryParameters = queryParameters.set('$search', <any>$search);
        }
        if (estado !== undefined && estado !== null) {
            queryParameters = queryParameters.set('estado', <any>estado);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<KoguiEvento>>(`${this.configuration.basePath}/kogui/eventos/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
